module.exports = __webpack_public_path__ + "static/media/HiConga808.5bcca160.wav";